
export default {
  install(Vue, options) {

    // v-focus
    Vue.directive('focus', {
      async inserted(el) {
        await Vue.nextTick()
        el.focus()
      },
    })

  },
}
